import { useTranslation } from "@impero-com/common/utils/i18n";
import { Button } from "@impero-com/ui";

export function Footer({
    onClose,
    onConfirm,
    confirmLabel,
    cancelLabel,
    destructive = false,
    loading = false,
    okDisabled = false,
}: {
    onClose: () => void;
    onConfirm: () => void;
    /** Names the action, e.g. "Archive". Never "Confirm". */
    confirmLabel: string;
    /** Defaults to "Cancel". Discard dialogs say "Keep editing" instead. */
    cancelLabel?: string;
    destructive?: boolean;
    loading?: boolean;
    okDisabled?: boolean;
}) {
    const { t } = useTranslation();
    return (
        <>
            <Button onClick={onClose} disabled={loading}>
                {cancelLabel ?? t("Cancel")}
            </Button>
            <Button
                variant={destructive ? "destructive" : "primary"}
                disabled={okDisabled}
                loading={loading}
                onClick={onConfirm}
            >
                {confirmLabel}
            </Button>
        </>
    );
}
